import { getSpanInformations } from 'src/services/languageSpanHelpers';
import { LanguageSpanProps } from './languageSpan.types';

// More informations: https://stackoverflow.com/questions/47343419/jsx-component-dangerouslysetinnerhtml
const LanguageSpan: (props: LanguageSpanProps) => JSX.Element = ({
  text,
  keyPrefix,
}) => {
  if (text) {
    const splittedText = text.split(/<span |<\/span>/g);

    const getSpanByText = (
      partOfText: string,
      index: number
    ): React.ReactNode => {
      const clearedSpan = getSpanInformations(partOfText);
      if (clearedSpan.language === undefined) {
        return clearedSpan.spanContent;
      }
      return (
        <span key={`${keyPrefix}-${index}`} lang={clearedSpan.language}>
          {clearedSpan.spanContent}
        </span>
      );
    };

    return (
      <>{splittedText.map((value, index) => getSpanByText(value, index))}</>
    );
  } else {
    return <></>;
  }
};

export default LanguageSpan;
